import { createContext } from 'react';

const initialState = {
  licenseList: [],
  viewList: [],
  editLicenseAssignment: null,
  licenseListIsLoading: true,
  sortField: 'name',
  sortDirection: 'asc',
  sortType: 'string',
  bulkRequestBody: [],
  searchTerm: '',
  licensesUserList: [],
  selectedUserList: [],
  filteredUserList: [],
  newlySelectedUserList: [],
  licenseParam: '',
  initialSelectedUserList: [],
  purchaseLicenseModalOpen: false,
  purchaseLicenseConfirmationPageOpen: false,
  purchaseLicenseAssignment: null,
  saveChangesModalOpen: false,
  pristine: false,
  tenRemovalsModalOpen: false,
};

const actionTypes = {
  SET_LICENSE_LIST: 'SET_LICENSE_LIST',
  SET_VIEW_LIST: 'SET_VIEW_LIST',
  FILTER_VIEW_LIST: 'FILTER_VIEW_LIST',
  UPDATE_VIEW_LIST: 'UPDATE_VIEW_LIST',
  SET_LICENSE_LIST_IS_LOADING: 'SET_LICENSE_LIST_IS_LOADING',
  SET_EDIT_LICENSE_ASSIGNMENT: 'SET_EDIT_LICENSE_ASSIGNMENT',
  SET_BULK_REQUEST_BODY: 'SET_BULK_REQUEST_BODY',
  SET_SEARCH_TERM: 'SET_SEARCH_TERM',
  SET_SORT: 'SET_SORT',
  SET_LICENSES_USER_LIST: 'SET_LICENSES_USER_LIST',
  SET_SELECTED_USER_LIST: 'SET_SELECTED_USER_LIST',
  FILTER_USER_LIST_BY_SEARCH: 'FILTER_USER_LIST_BY_SEARCH',
  SET_NEWLY_SELECTED_USER_LIST: 'SET_NEWLY_SELECTED_USER_LIST',
  SET_USER_CHECKED_STATE: 'SET_USER_CHECKED_STATE',
  RESET_EDIT_ASSIGNMENT_DRAWER: 'RESET_EDIT_ASSIGNMENT_DRAWER',
  SELECT_ALL_LICENSED_USERS: 'SELECT_ALL_LICENSED_USERS',
  SORT_LICENSES_USER_LIST: 'SORT_LICENSES_USER_LIST',
  TOGGLE_PURCHASE_LICENSE_MODAL: 'TOGGLE_PURCHASE_LICENSE_MODAL',
  TOGGLE_PURCHASE_LICENSE_CONFIRMATION_PAGE:
    'TOGGLE_PURCHASE_LICENSE_CONFIRMATION_PAGE',
  TOGGLE_SAVE_CHANGES_MODAL: 'TOGGLE_SAVE_CHANGES_MODAL',
  SET_PRISTINE: 'SET_PRISTINE',
  TOGGLE_TEN_REMOVALS_MODAL: 'TOGGLE_TEN_REMOVALS_MODAL',
};

const LicensesContext = createContext(initialState);

export { LicensesContext };
export { initialState };
export { actionTypes };
